import { combineReducers } from 'redux';

import report from './report/reducer';

export default combineReducers({
  report,
});



// WEBPACK FOOTER //
// ./src/pages/recipelisting/state/reducer.js